import React from 'react';
import PropTypes from 'prop-types'

import Home from '../../photos/home_2023.JPG'

import css from './Home.module.scss'

const HeadPicture = ({text}) => {
  return (
    <img src={Home} alt="CommunityLockerSS" className={css.headPicture} />
  )
}

HeadPicture.propTypes = {
  text: PropTypes.string
}

HeadPicture.defaultProps = {
  text: ''
}

export default HeadPicture;
